import { replaceValueNotExist } from '@/utils/replaceValueNotExisting'
import { moreThanOne } from '@/utils/handleNumbers'
import { ScheduledAppointmentsQueueListData } from './ScheduledAppointmentQueueMapper.types'
import { autoCapitalize } from '@/utils/autoCapitalize'

class ScheduledAppointmentsQueueMapper {
  toDomain(persistenceData: ScheduledAppointmentsQueueListData) {
    const ageUnity =
      moreThanOne(persistenceData?.idade) || persistenceData?.idade === 0
        ? 'anos'
        : 'ano'

    const formattedSpecialty = persistenceData?.nomeEspecialidade
      ? autoCapitalize(persistenceData?.nomeEspecialidade)
      : autoCapitalize(persistenceData?.tipoProfissional?.descricao)

    return {
      id: persistenceData?.id,
      patientId: persistenceData?.idPaciente,
      patientName: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomePaciente),
      ),
      patientNumber: replaceValueNotExist(persistenceData?.telefone),
      patientAge: `${persistenceData?.idade} ${ageUnity}`,
      clinicName: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeClinica),
      ),
      specialty: formattedSpecialty,
      scheduleDate: replaceValueNotExist(
        persistenceData?.dataAgendamento?.split(' ')[0],
      ),
      scheduleTime: replaceValueNotExist(
        persistenceData?.dataAgendamento?.split(' ')[1],
      ),
      inclusionUser: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeUsuarioInclusao),
      ),
      backofficeUser: persistenceData?.nomeUsuarioBackoffice
        ? autoCapitalize(persistenceData?.nomeUsuarioBackoffice)
        : 'Aguardando responsável',
      backofficeUserId: persistenceData?.idUsuarioBackoffice,
    }
  }
}

export default new ScheduledAppointmentsQueueMapper()
